import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { AuthenticationLoginUseCaseInterface } from 'domain/usecases';

export class RemoteAuthenticationLogin
  implements AuthenticationLoginUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: AuthenticationLoginUseCaseInterface.Params,
  ): Promise<AuthenticationLoginUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      body: params,
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body.user;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError(httpResponse?.body?.message);
      case HttpStatusCode.tooManyRequests:
        throw new InvalidCredentialsError(httpResponse?.body?.message);
      default:
        throw new UnexpectedError();
    }
  }
}
